module.exports = __webpack_public_path__ + "static/img/face3.16c6743.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face3.jpg
// module id = hRb3
// module chunks = 0